import { MdClose, MdOutlineFingerprint } from "react-icons/md";
import { ICON_SIZES } from "../../helpers/constants";
import useAuth from "../../hooks/useAuth";
import useCurrentUser from "../../hooks/useCurrentUser";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import Modal from "../Modal/Modal";
import ModalFooter from "../Modal/ModalFooter";
import { EButtonKind } from "../Button/ButtonTypes";

interface IRegisterPassKeyModal {
  onClose: () => void;
}

const RegisterPassKeyModal: React.FC<IRegisterPassKeyModal> = ({ onClose }) => {
  const { registerPassKey } = useAuth();
  const { userInfo } = useCurrentUser();
  const { t } = useTranslation();

  return (
    <Modal onEscape={() => onClose()} className="md:!max-w-[500px] md:!w-full">
      <Modal.Header
        title={t("Acceso sin contraseña")}
        onClose={() => onClose()}
      />
      <Modal.Body>
        <div className={clsx(["flex", "w-full", "text-sm", "md:text-base"])}>
          Crea una llave de acceso para iniciar sesión sin utilizar tu
          contraseña o desde otros dispositivos.
        </div>
      </Modal.Body>
      <ModalFooter
        actions={[
          {
            onClick: async () => {
              await registerPassKey({ email: userInfo.email });
            },
            text: "Crear",
            icon: <MdOutlineFingerprint size={ICON_SIZES.MD} />,
            kind: EButtonKind.SAVE,
          },
          {
            text: t("shared.close"),
            icon: <MdClose size={ICON_SIZES.MD} />,
            onClick: () => onClose(),
            kind: EButtonKind.NORMAL,
          },
        ]}
      />
    </Modal>
  );
};

export default RegisterPassKeyModal;
